import React from "react";
import { Image } from "react-bootstrap";

const LoginImage = () => {
  return (
    <>
      <div className="login-image-holder d-xl-block d-lg-block d-md-none d-none position-static">
        <div className="d-flex justify-content-between align-items-center">
          <div className="image-text-holder ps-4">
            <p className="font-13 font-weight-normal text-secondary py-5">
            Enjoy a smoother, more secure login experience with enhanced features and Log in today to explore the updates!
            </p>
          </div>
          {/* <div className="pe-3">
            <Image src="/assets/images/DIDI.svg" />
          </div> */}
        </div>
        <div className="pb-5 position-relative login-main-img px-4">
        <Image src="/assets/images/login-img.png" className="m-auto d-flex login-girl-img"/>
            <div className="develop-assets-img assets-img">
              <p className="font-16 font-weight-medium"><Image src="/assets/images/develop.svg" className="me-2"/> Develop</p>
            </div>
            <div className="inovate-assets-img assets-img">
              <p className="font-16 font-weight-medium"><Image src="/assets/images/inovate.svg"  className="me-2"/> Innovate</p>
            </div>
            <div className="deliver-assets-img assets-img">
              <p className="font-16 font-weight-medium"> Deliver<Image src="/assets/images/deliver.svg"  className="ms-2" /></p>
            </div>
            <div className="inspire-assets-img assets-img">
              <p className="font-16 font-weight-medium"> <Image src="/assets/images/inspire.jpg"  className="me-2" />Inspire</p>
            </div>
        </div>
      </div>
    </>
  );
};

export default LoginImage;
